/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const LOOKUP_OPTION_COLUMNS = [
  { id: "label", label: "Label", accessor: (row) => row.label || row.value, filterType: "text" },
  { id: "value", label: "Value", accessorKey: "value", filterType: "text" },
];
